import { Injectable } from '@angular/core';
import {
  MetaModel,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import { FormWidgetService } from '../form-widget.service';
import { StudentProfileFormDataService } from 'common/services/data-services/student-profile-data-service/student-profile-data.service';

import { SystemService } from 'common/services/core-services/system.service';
import { documentListDataService } from 'common/services/data-services/custom-service/documentlist-service';
import { packageListDataService } from 'common/services/data-services/custom-service/package-service';
import { StudentProfileModel } from 'common/models/page-models/studentprofile/formmodel/studentprofile-form.data.model';
import { StudentProfileMetaModel } from 'common/models/page-models/studentprofile/formmodel/studentprofile.form.meta.model';
import { UploadFileModel } from 'common/models/page-models/custom-model/uploadfile.model';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { BranchesGridDataService } from 'common/services/data-services/admin/branches/branches-grid-data.service';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { zoneListDataService } from 'common/services/data-services/custom-service/zoneList-service';
import { DistrictDataService } from 'common/services/data-services/custom-service/district-data.service';
import { ConsentDataService } from 'common/services/data-services/custom-service/consent.service';

@Injectable({
  providedIn: 'root',
})
export class StudentProfileWidgetService extends FormWidgetService<StudentProfileModel> {
  constructor(
    public ds: StudentProfileFormDataService,
    private ss: SystemService,
    private deocumentservice:documentListDataService,
    private packageListService:packageListDataService,
    private stateListService:stateListDataService,
    private category:BranchesGridDataService,
    private batch:BatchListDataService,
    private zone_name:zoneListDataService,
    private district:DistrictDataService,
    protected consentService: ConsentDataService
  ) {
    super(ds);
  }

  override prepareMetaModel(
    dataModel: StudentProfileModel,
    metaModel: StudentProfileMetaModel,
    routeData: WidgetModel
  ): Promise<StudentProfileMetaModel> {
    return new Promise<StudentProfileMetaModel>((resolve, reject) => {
      // metaModel.properties['state_name'].options =
      //   this.ss.dataStorage.state_List;
     // metaModel.properties['region'].options = this.ss.dataStorage.zone_name;
    //  metaModel.properties['batch_number'].options =
       // this.ss.dataStorage.batch_number;
     // metaModel.properties['placement_company_package_id'].options =
       // this.ss.dataStorage.package_list;
    //  metaModel.properties['branch_name'].options =
       // this.ss.dataStorage.branch_list;

        // this.district.postData({}).then((data)=>
        //   {
        //     metaModel.properties['district'].options = data.details
        //   });

         this.consentService.postData('').then((data) => {
          metaModel.properties['consent'] = data.details;
      })

        this.zone_name.postData({}).then((data)=>
          {
            metaModel.properties['region_id'].options = data.details
          });

      this.packageListService.postData({}).then((data)=>
      {
        metaModel.properties['placement_company_package'].options=data.details
      });

      this.batch.postData({}).then((data)=>
        {
          metaModel.properties['batch_id'].options=data.details;
         
        });
        this.category.postData({}).then((data)=>
          {
            metaModel.properties['branch_id'].options=data.details;
           
          });
  

      this.stateListService.postData({}).then((data)=>
        {
          metaModel.properties['state_id'].options=data.details;
         
        });

        this.deocumentservice.postData({}).then((data)=>{
          // console.log(data.details);
          
            this.mergeArrays(data.details, dataModel.apiStudentDocumentDetailsList, 'id','documentTypeId',String(dataModel.year))
            .then((mergedData) => {
              dataModel.studentDocumentDetails=mergedData;
              resolve(metaModel);
            })
            .catch((error) => {
              reject(error);
            });

        }).catch((err)=>{
            reject(err)
        })
        resolve(metaModel);
    });
  }

  Save(body, url) {
    this.ds.postLoginData(body, url).then((response) => {
      // console.log("RESPONSE",response);
      
      if (response.status === 'Success') {
        this.ss.showSuccess(response.msg);
      }

    });
  }

  getMetaModel(): MetaModel {
    const meta = new StudentProfileMetaModel();
    return meta.getMetaModel();
  }

  mergeArrays(array1, array2, key1, key2, periodValue): Promise<any> {
    // console.log(array1, array2, key1, key2, periodValue);
    // console.log('mergeArray');
    
    return new Promise((resolve, reject) => {
      try {
        const merged = [];
        const map = new Map();

        array1.forEach((item) => {
          map.set(item[key1], { ...item });
        });
        // console.log(map);
        

        const newArray = array2.filter((data) => {
          // console.log(periodValue);
          
          //  console.log(data.periodValue,periodValue);
          
          return data.periodValue == periodValue;
        });
        // console.log(newArray);
        

        newArray.forEach((item) => {
          // console.log(item);
          
          if (map.has(item[key2])) {
            map.set(item[key2], { ...map.get(item[key2]), ...item });
          } else {
            map.set(item[key2], { ...item });
          }        

        });
        // console.log(map);
        
        map.forEach((data) => {
          // console.log(data);
          
          const updateData = new UploadFileModel();
          updateData.documentTypeId = data.id;
          updateData.uploadDocId = data.UploadDocID;
          updateData.fileName = data.document_name;
          updateData.uploadedFileOriginalName = data.UploadedFileName;
          updateData.isAnnual = data.isAnnual;
          updateData.periodValue = periodValue;
          updateData.filePath = data.UploadedFileOriginalName;
          merged.push(updateData);
          // console.log(updateData);
          
        });
        // console.log(merged);
        
        resolve(merged);
      } catch (error) {
        reject(error);
      }
    });
  }
}
